import React, { createContext, useContext } from 'react';
import { LexicalEditor } from 'lexical';

export interface SeedMentionContextValue {
  editor: LexicalEditor | null;
  activeSeedId: string | null;
  onTagClick: (seedId: string, nodeKey: string) => void;
  onTagDelete: (nodeKey: string) => void;
  onEditComplete: (nodeKey: string, value: string, seedType: string) => void;
}

const SeedMentionContext = createContext<SeedMentionContextValue | null>(null);

export const SeedMentionProvider = SeedMentionContext.Provider;

export function useSeedMentionContext(): SeedMentionContextValue | null {
  return useContext(SeedMentionContext);
}

